var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.projectImpact)?_c('router-link',{attrs:{"to":{name: 'ProjectImpact', params: {id: _vm.projectImpact.id}}}},[_vm._v(" "+_vm._s(_vm.projectImpact.name)+" ")]):_c('span',[_vm._v(_vm._s(_vm.$t('common.misc.NA')))])
}
var staticRenderFns = []

export { render, staticRenderFns }